<template>
  <div id="app">
    <div v-if="showMobileWarning" class="mobile-overlay">
      <div class="mobile-popup">
        <h2>Sito in manutenzione</h2>
        <p>
          La versione mobile è attualmente in manutenzione, pertanto il sito potrebbe non essere visualizzato correttamente.
          Premere OK per continuare comunque sul sito
        </p>
        <button @click="closeWarning">OK</button>
      </div>
    </div>

    <TopBar />
    <NavBar/>
    <div class="pagecontent">
      <router-view />
    </div>
    <BottomBar />
  </div>
</template>

<script>
import NavBar from './components/NavBar.vue'
import TopBar from './components/TopBar.vue'
import BottomBar from './components/BottomBar.vue'


export default {
  name: 'App',
  components: {
    NavBar,
    TopBar,
    BottomBar
  },
  data() {
    return {
      showMobileWarning: false
    }
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.showMobileWarning = true
    }
  },
  methods: {
    closeWarning() {
      this.showMobileWarning = false
    }
  }
}
</script>

<style lang="scss">

@font-face {
  font-family: 'Futura';
  src: url('@/assets/fonts/futura-medium-webfont.woff2') format('woff2');
  font-weight: normal;
  font-style: normal;
}


#app {
  font-family: 'Futura', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  min-height: 100vh;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.pagecontent {
  margin-bottom: 8vh;

}

.mobile-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.mobile-popup {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 300px;
  text-align: center;
}

.mobile-popup button {
  margin-top: 1rem;
  padding: 0.5rem 1.5rem;
  border: none;
  background-color: #1f5f3b;
  color: white;
  border-radius: 6px;
  cursor: pointer;
}
</style>
